import { render, staticRenderFns } from "./birdEmbeddedSignupButton.vue?vue&type=template&id=47c4dbdc&"
import script from "./birdEmbeddedSignupButton.vue?vue&type=script&lang=ts&"
export * from "./birdEmbeddedSignupButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports